import styled from 'styled-components';
import { FONT_FAMILY, COLORS } from '@Commons';

interface ITextProps {
  fontSize?: string;
  fontFamily?: string;
  lineHeight?: string;
  padding?: string;
  textAlign?: string;
  color?: string;
  align?: string;
  cursor?: string;
}

export const Text = styled.div<ITextProps>`
  font-size: ${({ fontSize }) => fontSize || '28px'};
  line-height: ${({ lineHeight }) => lineHeight || '38px'};
  font-family: ${({ fontFamily }) => fontFamily || FONT_FAMILY.hellix.bold};
  padding: ${({ padding }) => padding || '0 0 0 0'};
  text-align: ${({ textAlign }) => textAlign || 'center'};
  color: ${({ color }) => color || COLORS.black};
  align-self: ${({ align }) => align || 'center'};
  cursor: ${({ cursor }) => cursor || 'auto'};

  .boldText {
    font-family: ${FONT_FAMILY.hellix.bold};
  }
`;

export const ReceiverContainer = styled.div`
  padding: 24px 0 8px 0;
`;

export const InstructionsContainer = styled.div`
  padding: 12px 16px;
  margin: 48px 0 48px 0;
  border-radius: 8px;
  background-color: ${COLORS.lightShadedGrey};
  border: 1px solid ${COLORS.lightGrey};
  gap: 12px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  max-width: 450px;
`;

export const A2FormMessage = styled.div`
  background-color: ${COLORS.lightBlueBackground};
  border: 1px solid ${COLORS.dividerBlue};
  max-width: 450px;
  font-size: 14px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
  padding: 12px;
  margin-top: 24px;
`;

interface IFlexContainerProps {
  row?: boolean;
  align?: string;
  padding?: string;
  margin?: string;
  backgroundColor?: string;
  borderRadius?: string;
  border?: string;
}

export const FlexContainer = styled.div<IFlexContainerProps>`
  display: flex;
  flex-direction: ${({ row }) => (row ? 'row' : 'column')};
  width: 100%;
  align-items: ${({ align }) => align};
  justify-content: ${({ align }) => align};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: ${({ borderRadius }) => borderRadius};
  border: ${({ border }) => border};
`;

export const ModalCloseButton = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  cursor: pointer;
`;

interface IModalContainerProps {
  gap?: string;
}

export const ModalContainer = styled.div<IModalContainerProps>`
  position: relative;
  width: 500px;
  padding: 32px 24px;
  margin: 20px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  gap: ${({ gap }) => gap || '0px'};
  background-color: ${COLORS.white};
  @media (max-height: 750px) {
    overflow-y: scroll;
    max-height: 95vh;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
